// extracted by mini-css-extract-plugin
module.exports = {"amount-frequency":"amount-frequency_amount-frequency__WlAjz"};